import { render, staticRenderFns } from "./ActivityBody.vue?vue&type=template&id=b98ad754&scoped=true&"
import script from "./ActivityBody.vue?vue&type=script&lang=ts&"
export * from "./ActivityBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98ad754",
  null
  
)

export default component.exports